import React from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import { EBSCO_URLS } from "../../../constants";
import logo from "./logo.svg";
import messages from "./header-messages";

import "./header.scss";

const Header = ({ intl }) => {
  return (
    <header className="header">
      <div className="header__contents">
        <img
          className="header__logo"
          src={logo}
          alt={intl.formatMessage(messages.ebscoLogo)}
        />
        <a
          href={EBSCO_URLS.SUPPORT_SITE}
          target="_blank"
          rel="noopener noreferrer"
          className="header__ebsco-link"
        >
          <FormattedMessage {...messages.ebscoSupportSite} />
        </a>
      </div>
    </header>
  );
};

export { Header };
export default injectIntl(Header);
